import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconProvider from '../icons/IconProvider';

function InformativeComponent(props: any) {
    return (
        <>
            <Stack direction="row" alignItems="center" gap={2} textAlign="left">
                <div className="icon-container">
                    <IconProvider id={props.icon} size="small" color="blue-filter" />
                </div>
                <Typography variant="caption" marginBottom={"0"} color={props.color}>
                    {props.content}
                </Typography>
            </Stack>
        </>);
}

export default InformativeComponent;